const gis = () => import('Views/gis/gis');

export default[
  { path: '/gis', component: gis },
];



// WEBPACK FOOTER //
// ./src/router/gis.js